import { gql } from '@apollo/client';
import DiscoverMeta from '../../pages/Discover/Meta';

export const DISCOVER_BRANDS_LIST_INFO = gql`
  query MyQuery($pageNo: Int!, $pageSize: Int!, $categoryName: String!) {
    allEventCategories {
      ...DiscoverMetaFragment
    }
    discoverSponsors(
      pageNo: $pageNo
      pageSize: $pageSize
      categoryName: $categoryName
    ) {
      totalCount
      data {
        description
        summary
        isFeatured
        isAdultonly
        isDeleted
        created
        likeCount
        liked
        sponsorId
        sponsorName
        slug
        heroPlayList {
          autoPlay
          expires
          id
          mediaUrl
          mobileHero
          published
          assets {
            assetId
            description
            basename
            hlsPlaylistUrl
            thumbnailUrl
            type
            mp4Url
            mimeType
            url
            webmUrl
          }
        }
      }
    }
  }
  ${DiscoverMeta.fragments.category}
`;

export const DISCOVER_PRODUCT_LIST_INFO = gql`
  query MyQuery($pageNo: Int!, $pageSize: Int!, $slug: String!) {
    allEventCategories {
      ...DiscoverMetaFragment
    }
    discoverProducts(pageNo: $pageNo, pageSize: $pageSize, slug: $slug) {
      totalCount
      data {
        id
        adminName
        created
        description
        discussionCount
        likeCount
        liked
        name
        slug
        summary
        reviewUrl
        reviewCount
        heroPlayList {
          autoPlay
          id
          expires
          mediaUrl
          mobileHero
          published
          assets {
            assetId
            basename
            description
            hlsPlaylistUrl
            mimeType
            mp4Url
            thumbnailUrl
            type
            url
            webmUrl
          }
        }
      }
    }
  }
  ${DiscoverMeta.fragments.category}
`;
